import { API_HOST } from './config'
export default {
  // CLINIC ROUTES
  CLINIC_TRAININGS: `${API_HOST}clinics/trainings/all_trainings`,
  CLINIC_ADD_TRAINING: `${API_HOST}clinics/trainings/add_training`,
  CLINIC_EDIT_TRAINING: `${API_HOST}clinics/trainings/edit_training`,
  CLINIC_DELETE_TRAINING: `${API_HOST}clinics/trainings/delete_training`
}